import "core-js/modules/es.array.push.js";
import commissionListComponent from "@/components/commission/CommissionListComponent.vue";
import ConditionalDiscountList from "@/components/conditionaldiscount/ConditionalDiscountList.vue";
import Error from "@/views/error/error.vue";
import { isAdminNotConsultant } from "@/js/http/auth";
export default {
  name: "adminCommissionsList",
  props: {
    loggedUserData: Object
  },
  components: {
    "commission-list": commissionListComponent,
    ConditionalDiscountList: ConditionalDiscountList,
    Error: Error
  },
  data: function data() {
    return {
      selectedTab: null,
      tabs: {
        commissions: "commissions",
        conditionalsDiscounts: "conditionalsDiscounts"
      },
      role: process.env.VUE_APP_ROLES_MANAGE_COMMISSION
    };
  },
  watch: {
    $route: function $route() {
      if (this.selectedTab != this.tabs[this.$route.query.tab]) {
        this.changeTab();
      }
    },
    selectedTab: function selectedTab(newVal, oldVal) {
      this.changeTab();
    }
  },
  created: function created() {
    this.changeTab();
  },
  methods: {
    isAdminNotConsultant: isAdminNotConsultant,
    selectTab: function selectTab(name) {
      this.selectedTab = this.tabs[name];
      this.$router.push({
        query: {
          tab: this.tabs[name]
        }
      }).catch(function () {});
    },
    changeTab: function changeTab() {
      if (this.$route.query.tab) {
        this.selectedTab = this.tabs[this.$route.query.tab];
      } else if (this.selectedTab) {
        this.selectedTab = this.tabs[this.selectedTab];
      } else {
        this.selectedTab = this.tabs.commissions;
      }
    }
  }
};